/* eslint-disable prefer-rest-params */
import React, { useEffect, useRef, useState } from "react";
import {
  Chart,
  LineController,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
} from "chart.js";

Chart.register(
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title
);

const LineChartInterpolation = ({ data }) => {
  const chartContainer = useRef(null);
  const [, setChartInstance] = useState(null);

  useEffect(() => {
    if (chartContainer && chartContainer.current) {
      //   const context = chartContainer.current.getContext("2d");
      const context = chartContainer.current;
      const newChartInstance = new Chart(context, {
        type: "line",
        options: {
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              display: true,
              title: {
                display: true,
              },
            },
            y: {
              display: true,
            },
          },
        },
        data,
      });
      setChartInstance(newChartInstance);
    }
  }, [chartContainer, data]);

  return <canvas ref={chartContainer} />;
};

export default LineChartInterpolation;
